import React, { Dispatch, FC, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { ColumnIDs } from "../Types";
import { useAddChatWidgetChannelMutation, useGetAppWithChannelsQuery } from "generated/graphql";
import { AppsTableCellSwitch } from "../components/AppsTableCellSwitch";
import { useWrapUrql } from "utils/graphql/useWrapUrql";

export interface AppsTableCellContainerProps {
    readonly columnId: ColumnIDs;
    readonly appId: string;
    readonly appIcon: string;
    readonly appName: string;
    readonly createdDate: string;
    readonly lastModifiedDate: string;
    readonly submitter: string;
    readonly status: string;
    readonly organizationId: string;
    readonly notes: string;
    onActionClick?(status: string, appId: string): void;
    showSnippetDialog: () => void;
    showSnippetDialogKey: (key: string) => void;
    setLoading: Dispatch<SetStateAction<boolean>>;
    valueNotes?: (note: string, id: string, status: string) => void;
}

export const AppsTableCellContainer: FC<AppsTableCellContainerProps> = (props) => {
    const {
        columnId,
        appIcon,
        appName,
        createdDate,
        lastModifiedDate,
        submitter,
        status,
        appId,
        organizationId,
        notes,
        onActionClick,
        showSnippetDialog,
        showSnippetDialogKey,
        valueNotes,
        setLoading } = props;

    const [applicationId, setApplicationId] = useState<string>("");

    const [getAppWithChannelData] = useGetAppWithChannelsQuery({
        pause: !applicationId,
        requestPolicy: "network-only",
        variables: { appId: applicationId, organizationId }
    });

    const channels = useMemo(() => {
        return getAppWithChannelData?.data?.app?.channels
    }, [getAppWithChannelData?.data?.app?.channels])

    const save = useWrapUrql(useAddChatWidgetChannelMutation(), {
        dispatchOnSuccess: [],
        onSuccessMessage: false
    });

    const handleLive = useCallback(async (channelsDisabled: boolean) => {
        setLoading(true)
        for (const currentChannel of channels) {
            await save({
                appId,
                channel: {
                    type: currentChannel.type,
                    disabled: !channelsDisabled,
                    id: currentChannel.id
                }
            });
        }
        setApplicationId("");
        setLoading(false)
    }, [appId, channels, save, setLoading])

    useEffect(() => {
        if (!applicationId) {
            setApplicationId(appId);
        }
    }, [appId, applicationId])

    return <>
        <AppsTableCellSwitch appId={appId}
            columnId={columnId}
            appIcon={appIcon}
            appName={appName}
            createdDate={createdDate}
            lastModifiedDate={lastModifiedDate}
            submitter={submitter}
            status={status}
            notes={notes}
            onActionClick={onActionClick}
            showSnippetDialog={showSnippetDialog}
            channels={channels}
            organizationId={organizationId}
            showSnippetDialogKey={showSnippetDialogKey}
            handleLive={handleLive}
            valueNotes={valueNotes}
        />

    </>

};
